import React, { useState } from "react";

function DeleteAccount() {
	const [emailRevealed, setEmailRevealed] = useState(false);

	// Email parts stored separately and encoded to avoid bot scraping
	const getEmail = () => {
		const parts = ["contact", "gymnote", "fr"];
		return parts[0] + "@" + parts[1] + "." + parts[2];
	};

	const handleRevealClick = () => {
		setEmailRevealed(true);
	};

	const handleEmailClick = (e) => {
		e.preventDefault();
		const email = getEmail();
		window.location.href = "mai" + "lto:" + email;
	};

	return (
		<section className="gs-page">
			<div className="gs-conteneur">
				<article className="gs-carte gs-doc-article" style={{ marginInline: "auto" }}>
					<h1>Supprimer mon compte GymNote</h1>

					<p>
						Cette page vous permet de demander la suppression de votre compte
						utilisateur de l'application <strong>GymNote</strong>, développée par
						<strong> FrenchMatrix</strong>.
					</p>

					<h2>Procédure de suppression</h2>
					<p>
						Pour supprimer définitivement votre compte GymNote et vos données
						associées, suivez ces étapes :
					</p>
					<ol>
						<li>
							<strong>Envoyez un email.</strong> Cliquez sur le bouton ci-dessous pour afficher l'adresse email de contact.
						</li>
						<li>
							<strong>Utilisez la même adresse email.</strong> Votre demande doit être envoyée depuis l'adresse email utilisée pour vous connecter à GymNote.
						</li>
						<li>
							<strong>Indiquez votre demande.</strong> Précisez dans votre email que vous souhaitez supprimer votre compte et vos données.
						</li>
					</ol>
					<p>
						{!emailRevealed ? (
							<button type="button" onClick={handleRevealClick} className="gs-btn gs-btn--contour">
								Cliquez pour afficher l'adresse email
							</button>
						) : (
							<a href="#contact" onClick={handleEmailClick}>
								{getEmail()}
							</a>
						)}
					</p>
					<p>
						Votre demande sera traitée dans un délai de <strong>30 jours</strong> maximum.
					</p>

					<h2>Données supprimées</h2>
					<p>
						Lors de la suppression de votre compte, les données suivantes seront
						<strong> définitivement effacées</strong> :
					</p>
					<ul>
						<li>Votre profil utilisateur et informations personnelles (nom, email)</li>
						<li>Votre historique complet d'entraînements</li>
						<li>Vos performances et statistiques enregistrées</li>
						<li>Vos exercices personnalisés</li>
						<li>Vos connexions et liens avec d'autres utilisateurs</li>
						<li>Vos modèles et programmes d'entraînement</li>
					</ul>

					<h2>Données conservées</h2>
					<p>
						Certaines données peuvent être conservées pour des raisons légales ou
						de sécurité :
					</p>
					<ul>
						<li>Logs de transactions (si applicable) - conservés 10 ans conformément aux obligations légales</li>
						<li>Données anonymisées à des fins statistiques (non identifiables)</li>
					</ul>

					<div className="gs-encadre">
						<h2>Important</h2>
						<p>
							Cette action est <strong>irréversible</strong>. Une fois votre
							compte supprimé, il sera impossible de récupérer vos données.
						</p>
					</div>
				</article>
			</div>
		</section>
	);
}

export default DeleteAccount;
